<template>
  <Modal :visible="true">
    <div class="confirm-modal">
      <div class="modal-body">
        <div class="modal-body-title">
          {{ config.title }}
        </div>
        <div class="modal-body-content">
          {{ config.content }}
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="!config.hideCancel" class="cancel" @click="cancel">取消</button>
        <button class="confirm" @click="confirm">确定</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';
export default {
  data() {
    return {
    }
  },
  components: {
    Modal,
  },
  props: {
    config: {
      type: Object
    },
    close: {
      type: Function
    }
  },
  methods: {
    cancel() {
      this.config.close && this.config.close();
      this.close();
    },
    confirm() {
      const result = this.config.confirm();
      if (result instanceof Promise) {
        result.finally(() => {
          this.cancel();
        })
      } else {
        this.cancel();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-modal {
  width: 416px;
  background: #FFFFFF;
  padding: 32px 32px 24px;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-body {
    margin-bottom: 20px;

    &-title {
      text-align: center;
      overflow: hidden;
      color: #000000d9;
      font-weight: 500;
      font-size: 16px;
    }

    &-content {
      margin-top: 8px;
      color: #000000d9;
      font-size: 14px;
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>